import React from 'react';
import { TextInput } from './inputs/TextInput';
import { MultiSelectInput } from './inputs/MultiSelectInput';
import { DoubleTextInput } from './inputs/DoubleTextInput';

/**
 * Input 컴포넌트 타입별 Factory
 * 새로운 Input 타입 추가 시 여기에 등록
 */
const INPUT_COMPONENTS = {
  single: {
    Text: TextInput,
    MultiSelect: MultiSelectInput,
  },
  group: {
    number: DoubleTextInput,
  },
};

/**
 * Input 컴포넌트를 생성하는 Factory 함수
 * @param {Object} config - Input 설정 객체
 * @param {Object} handlers - 공통 핸들러들
 * @returns {React.Component} 해당하는 Input 컴포넌트
 */
export const createInputComponent = (config, handlers) => {
  const InputComponent = 
    config.type === 'group' ?
    INPUT_COMPONENTS[config.type][config.fields[config.order].inputType] :
    INPUT_COMPONENTS[config.type][config.fields[0].inputType];
  
  if (!InputComponent) {
    console.warn(`Unknown input type: ${config.type}`);
    return null;
  }

  // key 로 currentStep(order)을 박아서 step 이 바뀔 때 컴포넌트가 새로 마운트되도록 함.
  // 이렇게 하지 않으면 TextInput 등의 로컬 state(userInput 등)가 이전 단계 값으로 남아있음.
  return React.createElement(InputComponent, {
    key: handlers?.order,
    ...config,
    ...handlers,
  });
};

/**
 * Input 타입별 검증 로직
 */
export const validateInput = (inputType, value, config) => {
  switch (inputType) {
    case 'Text':
      return validateTextInput(value, config.validation);
    case 'MultiSelect':
      return validateMultiSelectInput(value, config);
    case 'DoubleText':
      return validateDoubleTextInput(value, config.validation);
    default:
      return { isValid: false, message: 'Unknown input type' };
  }
};

const validateTextInput = (value, validation) => {
  const numValue = Number(value);
  const min = validation?.min || 1;
  const max = validation?.max || 999;
  
  if (!value || value.length === 0) {
    return { isValid: false, message: '값을 입력해주세요' };
  }
  
  if (isNaN(numValue) || numValue < min || numValue > max) {
    return { 
      isValid: false, 
      message: `${min}~${max}까지 입력 가능합니다.` 
    };
  }
  
  return { isValid: true };
};

const validateMultiSelectInput = (value, config) => {
  if (!value || value.length === 0) {
    return { isValid: false, message: '최소 하나 이상 선택해주세요' };
  }
  
  return { isValid: true };
};

const validateDoubleTextInput = (value, validation) => {
  // DoubleTextInput의 검증 로직 구현
  // 예: 두 개의 값이 모두 유효한지 확인
  if (!value || !value.first || !value.second) {
    return { isValid: false, message: '모든 필드를 입력해주세요' };
  }
  
  return { isValid: true };
};

